<div mdbModal #commonDocumentUploadWarningModal="mdbModal" class="modal fade left" id="commonDocumentUploadWarningModal"
  tabindex="-1">
  <div class="modal-dialog modal-notify modal-info modal-lg" role="document">
    <div class="modal-content">
      <app-spinner [isLoading]="isLoading"></app-spinner>

      <form #commonDocumentUploadWarningModalForm="ngForm" class="form-horizontal" role="form">
        <div class="modal-header">
          <h4 class="modal-title">{{ 'administration_somethingWentWrong_label' | translate }}</h4>
        </div>
        <div class="modal-body">
          <div>
            <div class="alert alert-warning p-3 text-center">
              <h6>{{ (modalDetails?.modalTitle ? modalDetails?.modalTitle  : 'administration_unableToUploadDocuments_label') | translate}}</h6>
              
              <div class="mt-3">
                {{'administration_sprigWarning_label' | translate}}
              </div>

            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button mdbBtn type="button" size="sm" class="btn btn-primary" mdbWavesEffect
            (click)="checkSprig()">{{'administration_refreshPage_label' | translate}}</button>
            <button mdbBtn type="button" size="sm" class="waves-light unique-color-dark text-white" mdbWavesEffect
            (click)="commonDocumentUploadWarningModal.hide()">{{'BTN_cancel_label' | translate}}</button>
        </div>
      </form>

    </div>
  </div>
</div>